import { NavLink } from 'react-router';
import { IconDrop } from '@/assets/svgs';
import { format } from '@/shared/lib';
import type { Database } from '@/shared/types';
import { HighlightText } from '@/shared/ui';

type StationSearchResult =
	Database['public']['Functions']['search_gas_stations']['Returns'][number];

type SearchStationResultItemProps = {
	station: StationSearchResult;
	highlight: string;
};

const SearchStationResultItem = ({
	station,
	highlight,
}: SearchStationResultItemProps) => {
	return (
		<li className="w-full list-none">
			<NavLink
				to={`/stations/${station.id}/detail`}
				className="flex w-full cursor-pointer items-center gap-2 px-5 py-3 text-left transition-colors hover:bg-mantang-gray-100"
			>
				<IconDrop className="size-4 shrink-0 text-mantang-gray-500" />
				<div className="flex min-w-0 flex-1 flex-col gap-1">
					<p className="truncate text-start font-inter font-medium text-mantang-gray-900 text-sm">
						<HighlightText highlight={highlight}>
							{station.station_name}
						</HighlightText>
					</p>
					<p className="truncate text-start font-inter text-mantang-gray-500 text-xs">
						<HighlightText highlight={highlight}>
							{station.road_number_address}
						</HighlightText>
					</p>
				</div>
				<p className="shrink-0 font-inter font-medium text-mantang-gray-900 text-xs">
					{format.formatToMetric(station.distance_meters)}
				</p>
			</NavLink>
		</li>
	);
};

export default SearchStationResultItem;
